import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getSpanNames } from "../api/client";
import type { ServiceSlug } from "../api/client";
import type { TimeRange } from "../utils/time";

export interface UseSpanNamesOptions {
  serviceSlug: ServiceSlug | null;
  timeRange?: TimeRange | null;
  limit?: number;
  enabled?: boolean;
}

export function useSpanNames({
  serviceSlug,
  timeRange,
  limit = 500,
  enabled = true,
}: UseSpanNamesOptions): { spanNames: string[]; loading: boolean } {
  const query = useQuery({
    queryKey: [
      "spanNames",
      serviceSlug,
      timeRange?.from?.toISOString(),
      timeRange?.to?.toISOString(),
      limit,
    ],
    enabled: !!serviceSlug && !!timeRange && enabled,
    queryFn: ({ signal }) =>
      getSpanNames(serviceSlug!, {
        rangeFrom: timeRange?.from,
        rangeTo: timeRange?.to,
        limit,
        signal,
      }),
  });

  return {
    spanNames: query.data ?? [],
    loading: query.isLoading,
  };
}
